"use strict";

function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
exports._ = _interop_require_default;
